import React from 'react'

const base = 'inline-flex items-center rounded-2xl px-4 py-2 text-sm font-medium shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors'

const variants = {
  primary: 'bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500',
  accent: 'bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500',
  outline: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-primary-500',
  subtle: 'bg-gray-100 text-gray-800 hover:bg-gray-200 focus:ring-gray-300',
}

export default function Button({ variant = 'primary', className = '', ...props }) {
  const cls = [base, variants[variant] || variants.primary, className].join(' ')
  return <button className={cls} {...props} />
}

